import React from 'react';

import { Box, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import { useConfigValue } from 'hooks/configs/use-config-value';
import useOrderNumber from 'hooks/use-order-number';
import { readableHour } from 'utils/restaurant';
import { TWELVE_HOUR_TIME_PARSE_FORMAT } from 'utils/restaurant/constants';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

interface IDeliveryOrderDetails {
  serverOrder: IServerOrder;
}

const DeliveryOrderDetails = ({ serverOrder }: IDeliveryOrderDetails) => {
  const { formatMessage } = useIntl();

  const orderNumber = useOrderNumber(serverOrder);
  const cardType = serverOrder?.cart?.payment?.cardType || null;
  const ccLast4 = serverOrder?.cart?.payment?.ccLast4 || null;

  const timeFormatConfig = useConfigValue({
    key: 'timeFormat',
    defaultValue: TWELVE_HOUR_TIME_PARSE_FORMAT,
  });

  const isCashApp = cardType === 'CASHAPP';

  return (
    <CardHeadingContainer>
      <CardHeading>{formatMessage({ id: 'orderDetailsHeading' })}</CardHeading>

      <Box marginTop="$4">
        {orderNumber ? (
          <CardText>
            <Text fontWeight="bold">{formatMessage({ id: 'orderNumber' })}: </Text>
            {orderNumber}
          </CardText>
        ) : null}
        {cardType && ccLast4 && !isCashApp && (
          <CardText>
            <Text fontWeight="bold">{formatMessage({ id: 'payment' })}: </Text>
            {formatMessage(
              { id: 'paymentXEndingInY' },
              {
                cardType,
                ccLast4,
              }
            )}
          </CardText>
        )}
        {isCashApp && (
          <CardText>
            <Text fontWeight="bold">{formatMessage({ id: 'payment' })}: </Text>
            {formatMessage({ id: 'cashAppPay' })}
          </CardText>
        )}
        <CardText>
          <Text fontWeight="bold">{formatMessage({ id: 'orderTime' })}: </Text>
          {readableHour({
            timeString: serverOrder.createdAt,
            ignoreMdmTimeParse: true,
            timeFormat: timeFormatConfig,
          })}
        </CardText>
      </Box>
    </CardHeadingContainer>
  );
};

export default DeliveryOrderDetails;
